// The subscription tiers, shared by the public /platform page and the admin
// console. `id` must match the plan names the admin API accepts
// (PLANS in aws/auth/functions/admin/index.mjs).
const GIB = 1024 ** 3;

export type PlanId = 'free' | 'creator' | 'pro';

export interface Plan {
  id: PlanId;
  name: string;
  storage: string;
  // The allowance an admin grants with the plan; null keeps the account on the
  // server's default allowance.
  storageBytes: number | null;
  price: string;
  note: string;
  features: string[];
  highlight: boolean;
}

// Prices are placeholders until the subscription is priced; the Free storage
// matches the default allowance every new account receives (15 GB).
export const PLANS: Plan[] = [
  {
    id: 'free',
    name: 'Free',
    storage: '15 GB',
    storageBytes: null,
    price: 'Free',
    note: 'during early access',
    features: ['Unlimited galleries', 'Private client links', 'Download-all ZIP', 'PIN & expiry dates'],
    highlight: false,
  },
  {
    id: 'creator',
    name: 'Creator',
    storage: '100 GB',
    storageBytes: 100 * GIB,
    price: 'Coming soon',
    note: 'monthly subscription',
    features: ['Everything in Free', 'Your logo on galleries', 'Video delivery', 'Gallery view & download stats'],
    highlight: true,
  },
  {
    id: 'pro',
    name: 'Pro',
    storage: '500 GB',
    storageBytes: 500 * GIB,
    price: 'Coming soon',
    note: 'monthly subscription',
    features: ['Everything in Creator', 'AI photo edits included', 'Priority support', 'Team access (planned)'],
    highlight: false,
  },
];

export const planName = (id: string): string => PLANS.find((plan) => plan.id === id)?.name ?? id;
